<form [formGroup]="form1" (ngSubmit)="create()" *ngIf="storesId else notStore">
    <div class="card">
      <div class="card-header text-center" style="text-transform: uppercase">
         USUARIO ADMINISTRADOR
      </div>
      <div class="card-body">
        <div class="row gx-3 mb-3">
          <div class="col-md-12">
            <label class="small mb-1" for="name">Nombre</label>
            <div class="input-group">
              <input type="text" class="form-control text-capitalize" formControlName="name" uppercaseInput />
            </div>
          </div>
          <div class="col-md-12">
            <label class="small mb-1" for="lastname">Apellidos</label>
            <div class="input-group">
              <input type="text" class="form-control text-capitalize" formControlName="lastname" uppercaseInput />
            </div>
          </div>
          <div class="col-md-12">
            <label class="small mb-1" for="rut">RUT/IDENTIFICACIÓN</label>
            <div class="input-group">
              <span class="input-group-text" id="basic-addon1"><i class="fa-solid fa-id-card"></i></span>
              <input type="text" class="form-control" formControlName="rut" uppercaseInput
                (keyup)="onFormatRut($event)" />
            </div>
          </div>
          <div class="col-md-12">
            <label class="small mb-1" for="location">Cambiar contraseña</label>
            <app-input-password-generate
              (selectedValue)="form1.get('pass')?.setValue($event)"
              [class]="'form-control'"
            />
            <app-warning-input-forms
              [input]="form1.get('cities_id')"
              [name]="'Ciudad'"
              [alertCss]="'alert-warning'"
            ></app-warning-input-forms>
          </div>
          <div class="col-md-12">
            <label class="small mb-1" for="state_id">ESTADO</label>
            <div class="input-group">
              <select class="form-select" formControlName="state_id">
                <option value="0">SELECCIONE</option>
                <option *ngFor="let item of items" [value]="item.id">{{item.tag}}</option>
              </select>
            </div>
          </div>
          <div class="col-sm-12">
            <label class="small mb-1" for="email">Email</label>
            <div class="input-group flex-nowrap">
              <span class="input-group-text" id="addon-wrapping"><i class="fa-regular fa-envelope"></i></span>
              <input type="email" class="form-control" (keyup)="checkEmail()"  placeholder="Email  contacto" formControlName="email" />
            </div>
          </div>
          <div class="col-sm-12">
            <label class="small mb-1" for="phone">Tel.</label>
            <div class="input-group flex-nowrap">
              <span class="input-group-text" id="addon-wrapping"><i class="fa-solid fa-phone"></i>+56 9</span>
              <input type="email" class="form-control" minlength="8" maxlength="8" placeholder="8 digitos" (keyup)="checkPhoneNumber()" placeholder="Telefono contacto"
               formControlName="phone" />
            </div>
          </div>
          <div class="col-md-12 mt-2" *ngIf="level>=99">
            <label class="small mb-1" for="notification">AJUSTES</label>
            <div class="form-check form-switch ms-4">
              <input class="form-check-input" type="checkbox" role="switch" (click)="activeSendVisSms($event)" minlength="8" maxlength="8"
              [checked]="form1.get('send_not_vis_sms')?.value==1" id="send_not_sms" [disabled]="notSendVisSms">
              <label class="form-check-label" for="send_not_vis_sms">Recibir notificación SMS (Ingreso Visitante)</label>
            </div>
            <div class="form-check form-switch ms-4">
              <input class="form-check-input" type="checkbox" (change)="activeSendVisEmail($event)" role="switch" id="send_not_vis_email"
                [checked]="form1.get('send_not_vis_email')?.value==1" [disabled]="notSendVisEmail">
              <label class="form-check-label" for="send_not_vis_email">Recibir notificación EMAIL (Ingreso Visitante)</label>
            </div>
            <div class="form-check form-switch ms-4">
              <input class="form-check-input" type="checkbox" role="switch" (click)="activeSendProvSms($event)" 
              [checked]="form1.get('send_not_prov_sms')?.value==1" id="send_not_sms" [disabled]="notSendProvSms">
              <label class="form-check-label" for="send_not_prov_sms">Recibir notificación SMS (Ingreso Proveedor)</label>
            </div>
            <div class="form-check form-switch ms-4">
              <input class="form-check-input" type="checkbox" (change)="activeSendProvEmail($event)" role="switch" id="send_not_prov_email"
                [checked]="form1.get('send_not_prov_email')?.value==1" [disabled]="notSendProvEmail">
              <label class="form-check-label" for="send_not_prov_email">Recibir notificación EMAIL (Ingreso Proveedor)</label>
            </div>
          </div>
        </div>
        <button class="btn btn-primary w-100" type="submit">CREAR</button>
      </div>
    </div>
  </form>
  <ng-template #notStore>
    <h2>No se recibio el identificador de la bodega, que se debe asociar</h2>
  </ng-template>